import React, { useEffect, useState } from 'react'
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  ScrollView,
  TextInput,
  KeyboardAvoidingView,
  Platform,
  Image,
  Alert,
  ActivityIndicator,
  Dimensions
} from 'react-native'
import { colorPalette, globalStyles } from '../../../static/styles/global'
import { Ionicons, MaterialIcons, AntDesign } from '@expo/vector-icons'
import Card from '../../../components/shared/card/Card'
import Select from '../../../components/shared/form/Select'
import CustomButton from '../../../components/shared/button/Button'
import ModalPopup from '../../../components/shared/modal/ModalPopup'
import { useLabourStore } from '../../../stores/labour'
import { usepaycheckStore } from '../../../stores/paycheck'
import * as ImagePicker from 'expo-image-picker'
import * as DocumentPicker from 'expo-document-picker'
import * as WebBrowser from 'expo-web-browser'
import { startActivityAsync } from 'expo-intent-launcher'
import ScanOrUploadDeposit from '../../../components/board/ScanOrUploadDeposit'
import { AlertWeb } from '../../../utils'
import {
  excludeExtensions,
  getFormData
} from '../../../helpers/onboardingHelper'
import { FILE_EXTENSIONS } from '../../../constants/onboardingConstants'
import { useInitializeStore } from '../../../stores/initialize'
import { Formik } from 'formik'
import * as yup from 'yup'
import Deposithelper from './Deposithelper'
import { useFocusEffect } from '@react-navigation/native'
import { useHomeStore } from '../../../stores/home'
import { useFormsStore } from '../../../stores/onboarding'
import Toast from 'react-native-toast-message'
import HomeDetailsHeader from '../../home/HomeDetailsHeader'

const UpdateDeposit = ({ navigation, route }: any) => {
  const { params } = route
  const { mode, essUserOnBoardingFormKey, essUserOnBoardingKey } = params
  console.log("update", essUserOnBoardingFormKey)
  const paycheckstore = usepaycheckStore()
  const initializestore = useInitializeStore()
  const homestore = useHomeStore()
  const formsstore = useFormsStore()
  useFocusEffect(
    React.useCallback(() => {
      paycheckstore.getDepositDetails(initializestore.initializeData.userkey)
    }, [])
  )
  const [selectedOption, setSelectedOption] = useState<any>('Checking Account')

  const [imgData, setImgData] = useState<any>(null)
  const [uploadVisible, setUploadVisible] = useState(false)
  const [show, setShow] = useState(false)
  const [routingError, setRoutingError] = useState<string | null>(null)
  const [isFetchingBank, setIsFetchingBank] = useState(false)
  const [bankModalVisible, setBankModalVisible] = useState(false)

  const handleSelect = (selectedOption: string | null) => {
    setSelectedOption(selectedOption)
  }
  const handlePickImage = async () => {
    const options = {
      allowsEditing: false,
      quality: 1
    }
    const result = await ImagePicker.launchImageLibraryAsync(options)

    if (!result.canceled) {
      try {
        const formData = await getFormData(result.assets[0].uri, 'checkimage', [
          '.png',
          '.jpg',
          '.jpeg'
        ])
        setImgData(formData)
        setShow(false)
      } catch (error: any) {
        if (Platform.OS === 'web') {
          AlertWeb('Image not supported', error.message)
        } else {
          Alert.alert('Image not supported', error.message)
        }
      } finally {
        setUploadVisible(false)
      }
    }
  }
  const handlePickDocument = async () => {
    const options = {}
    const result = await DocumentPicker.getDocumentAsync(options)
    if (!result.canceled) {
      try {
        const formData = await getFormData(result.assets[0].uri, 'checkimage', [
          '.png',
          '.jpg',
          '.jpeg'
        ])
        setImgData(formData)
        setShow(false)
      } catch (error: any) {
        if (Platform.OS === 'web') {
          AlertWeb('File not supported', error.message)
        } else {
          Alert.alert('File not supported', error.message)
        }
      } finally {
        setUploadVisible(false)
      }
    }
  }
  const intialValues = {
    accountNumber: '',
    routingNumber: '',
    amount: '',
    bank: ""
  }
  const count = paycheckstore.depositData?.count
  const w4schema = (count: any) => {
    const baseSchema = {
      accountNumber: yup
        .string()
        .matches(/^[0-9]+$/, 'Please enter only numeric values')
        .required('Account Number is a required field'),
      routingNumber: yup
        .string()
        .matches(/^[0-9]{9}$/, "Routing Number must be exactly 9 digits")
        .required("Routing Number is a required field"),
      bank: yup.string().required("Financial Institution is a required field"),
      amount: yup
        .string()
        .matches(/^[0-9]+$/, 'Please enter only numeric values')
    }


    if (count && count > 0) {
      baseSchema.amount = baseSchema.amount.required(
        'Amount is a required field'
      )
    }

    return yup.object(baseSchema)
  }
  const schema = w4schema(count)


  const data = {
    completeOnline: false,
    essUserKey: initializestore.initializeData?.userkey,
    formKey: essUserOnBoardingFormKey,
  }


  const handlesubmit = async () => {
    // if (data?.formKey == null || data?.formKey == undefined) {
    //   await Toast.show({
    //     type: 'error',
    //     position: 'bottom',
    //     text1: 'Something went wrong. Please try again.',
    //     visibilityTime: 3000,
    //     autoHide: true,
    //     topOffset: 60,
    //   });
    //   return;
    // }
    const response = await formsstore.postdirectdepositonline(data)

    if (response?.success) {
      await Toast.show({
        type: 'success',
        position: 'bottom',
        text1: response?.message,
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60,
        onHide: () => {
          navigation.replace('OnboardingForms')
        }
      })
    }
    else {
      await Toast.show({
        type: 'error',
        position: 'bottom',
        text1: response?.message,
        visibilityTime: 3000,
        autoHide: true,
        topOffset: 60
      })
    }
  }



  return (
    <KeyboardAvoidingView
      behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
      style={{ flex: 1 }}
    >
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <HomeDetailsHeader
            navScreen='OnboardingForms'
            navLabel='Forms'
            title=' Update Direct Deposit Form'
          />
        </View>
      </View>

      <View style={[globalStyles.containerOverlap, { flex: 1 }]}>
        <Formik
          initialValues={{ ...intialValues }}
          validationSchema={schema}
          onSubmit={async (values, actions) => {
            if (routingError) return
            if (homestore.homeData?.hasDepositForm) {
              if (imgData) {
                const data: any = await paycheckstore.updateDirectDeposit(
                  values.amount,
                  initializestore.initializeData?.userkey,
                  values.accountNumber,
                  selectedOption,
                  values.routingNumber,
                  imgData,
                  values?.bank
                )
                if (data?.success) {
                  actions.resetForm()
                  setRoutingError(null)
                  paycheckstore.getDepositDetails(
                    initializestore.initializeData.userkey
                  )
                }
              } else {
                setShow(true)
              }
            } else {
              const data: any = await paycheckstore.updateDirectDeposit(
                values.amount,
                initializestore.initializeData?.userkey,
                values.accountNumber,
                selectedOption,
                values.routingNumber,
                imgData,
                values?.bank
              )
              if (data?.success) {
                actions.resetForm()
                setRoutingError(null)
                paycheckstore.getDepositDetails(
                  initializestore.initializeData.userkey
                )
              }
            }
          }}
        >
          {(props) => (
            <ScrollView>
              <Card>
                <View style={{ marginBottom: 10 }}>
                  <Deposithelper
                    fkey={essUserOnBoardingFormKey}
                    obkey={essUserOnBoardingKey}
                    mode={mode}
                  />
                </View>

                {mode === 'online' && (
                  <CustomButton
                    isDisabled={count > 0 ? false : true}
                    text={'Submit information'}
                    onPress={() =>
                      navigation.navigate('Directdepositonline', {
                        essUserOnBoardingFormKey,
                        essUserOnBoardingKey
                      })
                    }
                  />
                )}

                {formsstore.loading ? <ActivityIndicator /> :
                  mode != 'online' && (
                    <CustomButton
                      isDisabled={count > 0 ? false : true}
                      text={'Submit information'}
                      onPress={handlesubmit}
                    />
                  )}

                {paycheckstore.depositData?.count < 3 ? (
                  <>
                    <View
                      style={[
                        globalStyles.hDirection,
                        globalStyles.hBetweenItems,
                        globalStyles.mb2
                      ]}
                    >
                      <View style={{ justifyContent: 'center' }}>
                        <Text
                          style={[
                            globalStyles.inputLabel,
                            globalStyles.inputLabelLarge,
                            globalStyles.inputLabelPrimary
                          ]}
                        >
                          {'Routing Number'}
                        </Text>
                      </View>
                      <View style={{ width: '28%', overflow: 'hidden', justifyContent: 'center' }}>
                        <TextInput
                          style={[
                            globalStyles.input,
                            globalStyles.inputLight,
                            globalStyles.inputReadOnly
                          ]}
                          value={props.values.routingNumber}
                          keyboardType="numeric"
                          maxLength={9}
                          onChangeText={async (text) => {
                            if (text === '' || /^\d+$/.test(text)) {
                              props.setFieldValue('routingNumber', text)
                              if (text.length === 9) {
                                setIsFetchingBank(true)
                                setRoutingError(null)
                                try {
                                  const response = await paycheckstore.fetchBankNameByRoutingNumber(text)
                                  let bankName = ''
                                  if (response?.data?.bankDetailsList?.[0]?.bankName) {
                                    bankName = response.data.bankDetailsList[0].bankName
                                  } else if (typeof response === 'string') {
                                    bankName = response
                                  } else {
                                    bankName = response?.financialInstitution || response?.bankName || response?.bank || ''
                                  }
                                  if (bankName && bankName.trim() !== '') {
                                    props.setFieldValue('bank', bankName)
                                    setRoutingError(null)
                                  } else {
                                    props.setFieldValue('bank', '')
                                    setRoutingError('Invalid routing number entered. Please check the number with your bank and try again. If you have verified accuracy and are still receiving this error please ask your admin to contact FMS Help Desk for assistance.')
                                  }
                                } catch (error) {
                                  props.setFieldValue('bank', '')
                                  setRoutingError('Invalid routing number entered. Please check the number with your bank and try again. If you have verified accuracy and are still receiving this error please ask your admin to contact FMS Help Desk for assistance.')
                                } finally {
                                  setIsFetchingBank(false)
                                }
                              } else {
                                props.setFieldValue('bank', '')
                                setRoutingError(null)
                              }
                            }
                          }}
                        />
                        {isFetchingBank && (
                          <ActivityIndicator
                            size="small"
                            color={colorPalette.primary}
                            style={{ position: 'absolute', right: 5 }}
                          />
                        )}
                        {(props.touched.routingNumber && props.errors.routingNumber) || routingError ? (
                          <Text style={globalStyles.dangerAlert}>
                            {props.errors.routingNumber || routingError}
                          </Text>
                        ) : null}
                      </View>
                    </View>
                    <View
                      style={[
                        globalStyles.hDirection,
                        globalStyles.hBetweenItems,
                        globalStyles.mb2
                      ]}
                    >
                      <View style={{ justifyContent: 'center' }}>
                        <Text
                          style={[
                            globalStyles.inputLabel,
                            globalStyles.inputLabelLarge,
                            globalStyles.inputLabelPrimary
                          ]}
                        >
                          {'Account Number'}
                        </Text>
                      </View>
                      <View style={{ width: '28%', overflow: 'hidden' }}>
                        <TextInput
                          style={[
                            globalStyles.input,
                            globalStyles.inputLight,
                            globalStyles.inputReadOnly
                          ]}
                          value={props.values.accountNumber}
                          keyboardType="numeric"
                          onChangeText={(text) => {
                            if (text === '' || /^\d+$/.test(text)) {
                              props.handleChange('accountNumber')(text)
                            }
                          }}
                        />
                        {props.touched.accountNumber &&
                          props.errors.accountNumber && (
                            <Text style={globalStyles.dangerAlert}>
                              {props.errors.accountNumber}
                            </Text>
                          )}
                      </View>
                    </View>
                    <View
                      style={{
                        flexDirection: 'row',
                        justifyContent: 'space-between'
                      }}
                    >
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary,
                          { marginVertical: 10 }
                        ]}
                      >
                        Type of Account
                      </Text>
                      <View style={{ width: '28%', overflow: 'hidden' }}>
                        <Select
                          title="Select Account Type"
                          options={['Savings Account', 'Checking Account']}
                          selectedOption={selectedOption}
                          onSelect={handleSelect}
                          textColor="primary"
                        />
                      </View>
                    </View>

                    <View
                      style={[
                        globalStyles.hDirection,
                        globalStyles.hBetweenItems,
                        globalStyles.mb2
                      ]}
                    >
                      <View style={{ justifyContent: 'center' }}>
                        <Text
                          style={[
                            globalStyles.inputLabel,
                            globalStyles.inputLabelLarge,
                            globalStyles.inputLabelPrimary
                          ]}
                        >
                          {'Financial Institution'}
                        </Text>
                      </View>
                      <TouchableOpacity
                        style={{ width: '28%', overflow: 'hidden' }}
                        onPress={() => {
                          setBankModalVisible(true)
                        }}
                        activeOpacity={0.7}
                      >
                        <TextInput
                          style={[
                            globalStyles.input,
                            globalStyles.inputLight,
                            globalStyles.inputReadOnly
                          ]}
                          value={props.values.bank}
                          editable={false}
                          pointerEvents="none"
                          onChangeText={(text) => {
                            props.handleChange('bank')(text)
                          }}
                        />
                        {props.touched.bank &&
                          props.errors.bank && (
                            <Text style={globalStyles.dangerAlert}>
                              {props.errors.bank}
                            </Text>
                          )}
                      </TouchableOpacity>
                    </View>
                    <ModalPopup
                      visible={bankModalVisible}
                      position="middle"
                      screen="dropdown"
                      flatBottom={false}
                    >
                      <View style={styles.modalHeader}>
                        <Text
                          style={[
                            globalStyles.text,
                            globalStyles.fs18,
                            globalStyles.fwBold,
                            globalStyles.blackTextColor
                          ]}
                        >
                          Financial Institution
                        </Text>
                        <TouchableOpacity
                          onPress={() => setBankModalVisible(false)}
                        >
                          <Ionicons
                            name="close-sharp"
                            size={24}
                            color={colorPalette.black}
                          />
                        </TouchableOpacity>
                      </View>
                      <View style={styles.modalBody}>
                        <Text
                          style={[
                            globalStyles.text,
                            globalStyles.fs16,
                            globalStyles.fwSemiBold,
                            { paddingVertical: 15, paddingHorizontal: 10, textAlign: 'left' }
                          ]}
                        >
                          {props.values.bank || 'No financial institution found'}
                        </Text>
                        <View
                          style={{
                            alignItems: 'center',
                            marginTop: 10,
                            marginBottom: 5
                          }}
                        >
                          <View style={{ width: 100 }}>
                            <CustomButton
                              text="OK"
                              onPress={() => setBankModalVisible(false)}
                              color="primary"
                            />
                          </View>
                        </View>
                      </View>
                    </ModalPopup>
                    {paycheckstore.depositData?.count != 0 && (
                      <View
                        style={[
                          globalStyles.hDirection,
                          globalStyles.hBetweenItems,
                          globalStyles.mb2
                        ]}
                      >
                        <View style={{ justifyContent: 'center' }}>
                          <Text
                            style={[
                              globalStyles.inputLabel,
                              globalStyles.inputLabelLarge,
                              globalStyles.inputLabelPrimary
                            ]}
                          >
                            {'Amount'}
                          </Text>
                        </View>
                        <View style={{ width: '28%' }}>
                          <TextInput
                            style={[
                              globalStyles.input,
                              globalStyles.inputLight,
                              globalStyles.inputReadOnly
                            ]}
                            value={props.values.amount}
                            keyboardType="numeric"
                            onChangeText={(text) => {
                              if (text === '' || /^\d+$/.test(text)) {
                                props.handleChange('amount')(text)
                              }
                            }}
                          />
                          {props.touched.amount && props.errors.amount && (
                            <Text style={globalStyles.dangerAlert}>
                              {props.errors.amount}
                            </Text>
                          )}
                        </View>
                      </View>
                    )}
                    <ScanOrUploadDeposit
                      title={`Scan or Upload check`}
                      visible={uploadVisible}
                      setVisible={setUploadVisible}
                      scanDocumentsAction={() => { }}
                      photoLibraryAction={handlePickImage}
                      importFilesAction={handlePickDocument}
                    />
                    <View
                      style={{
                        flexDirection: 'row',
                        justifyContent: 'space-between'
                      }}
                    >
                      <Text
                        style={[
                          globalStyles.inputLabel,
                          globalStyles.inputLabelLarge,
                          globalStyles.inputLabelPrimary,
                          { marginTop: 10 }
                        ]}
                      >
                        Upload Check
                      </Text>
                      <TouchableOpacity
                        onPress={() => {
                          setUploadVisible(!uploadVisible)
                        }}
                        style={[
                          globalStyles.flexOne,
                          globalStyles.hEndItems,
                          globalStyles.vEndItems,
                          { marginTop: 7 }
                        ]}
                      >
                        <AntDesign
                          name="upload"
                          size={24}
                          color={colorPalette.tertiary}
                        />
                      </TouchableOpacity>
                    </View>
                    {show && (
                      <Text style={{ textAlign: 'right', color: 'red' }}>
                        Please select a Image
                      </Text>
                    )}
                  </>

                ) : <></>}
                <View style={{ marginTop: 10 }}>
                  {paycheckstore.loading ? (
                    <ActivityIndicator size="large" />
                  ) : (
                    <>
                      {paycheckstore.depositData?.count < 3 ? (
                        <View style={{ flex: 1, justifyContent: 'flex-end' }}>
                          <View style={{ margin: 10 }}>
                            <CustomButton
                              text={'Add Account'}
                              onPress={props.handleSubmit}
                            />
                          </View>
                        </View>
                      ) : (
                        <></>
                      )}
                    </>
                  )}
                </View>
                {paycheckstore.depositData?.count < 3 && (
                  <View
                    style={{
                      justifyContent: 'flex-end',
                      paddingBottom: 10
                    }}
                  >
                    <Image
                      style={{
                        width: '100%',
                        height: 250,
                        resizeMode: 'contain',
                        minHeight: 250
                      }}
                      source={require('../../../../assets/Images/check.jpg')}
                    />
                  </View>
                )}
              </Card>
            </ScrollView>
          )}
        </Formik>
      </View>

    </KeyboardAvoidingView>
  )
}

const styles = StyleSheet.create({
  custom: {
    justifyContent: 'center',
    flexDirection: 'row',
    paddingLeft: 16,
    paddingRight: 16,
    height: 40,
    width: '90%',
    alignItems: 'center',
    backgroundColor: '#0088CF',
    color: 'black',
    borderWidth: 0,
    borderRadius: 11,
    marginTop: 5
  },
  custom2: {
    justifyContent: 'center',
    flexDirection: 'row',
    height: 40,
    width: '95%',
    paddingLeft: 16,
    paddingRight: 16,
    alignItems: 'center',
    alignSelf: 'center',
    borderWidth: 0,
    borderRadius: 10
  },
  modalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    paddingHorizontal: 16,
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderColor: colorPalette.darkLight
  },
  modalBody: {
    padding: 16
  }
})

export default UpdateDeposit
